import React, { useState } from 'react';
import { PageContentExterneDto } from '../../../../services/dtos/page-content-externe.dto';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Button, Grid, Paper, Typography } from '@mui/material';

/**
 * A form component for editing content blocks.
 *
 * @param {Object} props - The component props.
 * @param {PageContentExterneDto} props.fieldContent - The initial content of the content block.
 * @param {function} props.handleSubmit - The submit callback function. Takes an object with the new content as its parameter.
 * @param {boolean} props.validate - Indicates whether the form should be validated.
 *
 * @return {JSX.Element} The rendered form component.
 */
export default function ContentBlockForm(props: {
    fieldContent: PageContentExterneDto;
    handleSubmit: any;
    validate: boolean;
}): JSX.Element {
    // Contenu entré dans l'éditeur de texte, prend à l'initialisation la valeur actuelle du champ
    const [value, setValue] = useState(props.fieldContent.valeur);

    // Handle submit function.
    const handleSubmit = (): void => {
        props.handleSubmit({ contenu: value });
    };

    return (
        <Paper sx={{ padding: '20px' }}>
            <Grid container>
                <Grid item xs={12}>
                    <ReactQuill theme="snow" value={value} onChange={setValue} />
                </Grid>
                <Grid item xs={12} sx={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Typography variant={'button'}>
                        <Button type="submit" variant="contained" disabled={props.validate} onClick={handleSubmit}>
                            Valider
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}
